import {Component, EventEmitter, forwardRef, input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {
	IonButton,
	IonButtons,
	IonContent,
	IonHeader,
	IonItem,
	IonRadio,
	IonRadioGroup,
	IonSearchbar,
	IonTitle,
	IonToolbar
} from '@ionic/angular/standalone';

@Component({
	           selector: 'app-ion-single-search-select',
	           standalone: true,
	           imports: [
		           IonButton,
		           IonButtons,
		           IonContent,
		           IonHeader,
		           IonItem,
		           IonSearchbar,
		           IonTitle,
		           IonToolbar,
		           IonRadio,
		           IonRadioGroup,
		           FormsModule
	           ],
	           templateUrl: './ionic-single-search-select.component.html',
	           providers: [
		           {
			           provide: NG_VALUE_ACCESSOR,
			           useExisting: forwardRef(() => IonicSingleSearchSelectComponent),
			           multi: true
		           }
	           ]
           })
export class IonicSingleSearchSelectComponent implements OnInit, ControlValueAccessor {
	items = input.required<Record<string, unknown>[]>();
	title = input.required<string>();
	displayValue = input.required<string>();
	indexValue = input.required<string>();
	placeholder = input.required<string>();
	color = input<string>('dark');

	selectedValue: unknown;

	@Output() selectionCancel = new EventEmitter<void>();
	@Output() selectionConfirm = new EventEmitter<unknown>();
	@Output() valueChange = new EventEmitter<unknown>();

	filteredItems: Record<string, unknown>[] = [];
	workingSelectedValue: unknown | undefined;

	ngOnInit() {
		this.filteredItems = [...this.items()];
		this.workingSelectedValue = this.selectedValue;
	}

	cancelChanges() {
		this.selectionCancel.emit();
	}

	confirmChanges() {
		this.selectionConfirm.emit(this.selectedValue);
	}

	searchbarInput(event: Event) {
		const inputElement = event.target as HTMLInputElement;
		this.filterList(inputElement.value);
	}

	filterList(searchQuery: string | undefined) {
		if (searchQuery === undefined || searchQuery.trim() === '') {
			this.filteredItems = [...this.items()];
		} else {
			const normalizedQuery = searchQuery.toLowerCase();
			this.filteredItems = this.items().filter((item) => {
				const displayVal = item[this.displayValue()];
				return typeof displayVal === 'string' && displayVal.toLowerCase().includes(normalizedQuery);
			});
		}
	}

	// Méthode pour mettre à jour la valeur du modèle
	writeValue(value: unknown): void {
		this.selectedValue = value;
	}

	// Méthode pour gérer les changements effectués dans le composant
	registerOnChange(fn: (value: unknown) => void): void {
		this.onChange = fn;
	}

	// Méthode pour enregistrer la méthode touch (utile pour le formulaire)
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	onValueChanged(value: unknown) {
		this.selectedValue = value;
		this.onChange(value); // notifier Angular
		this.onTouched();     // marquer comme "touché"
		this.valueChange.emit(value); // si besoin côté parent
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onChange = (_unused: unknown) => {};
	onTouched = () => {};
}
